export function drawNetworkDiagnostics(snapshot: { size: number; nodes: Array<{ id: number; signal: number[] }>; contributions: Record<string, number[]>; finalImage: number[] }): void {
  const draw = (id: string, values: readonly number[], color: boolean) => {
    const canvas = document.getElementById(id) as HTMLCanvasElement | null;
    const context = canvas?.getContext("2d"); if (!context) return;
    const image = context.createImageData(snapshot.size, snapshot.size);
    for (let pixel = 0; pixel < snapshot.size * snapshot.size; pixel++) {
      const offset = pixel * 4;
      if (color) { image.data[offset] = Math.round(255 * Math.max(0, Math.min(1, values[pixel * 3] ?? 0))); image.data[offset + 1] = Math.round(255 * Math.max(0, Math.min(1, values[pixel * 3 + 1] ?? 0))); image.data[offset + 2] = Math.round(255 * Math.max(0, Math.min(1, values[pixel * 3 + 2] ?? 0))); }
      else { const value = Math.round(255 * Math.max(0, Math.min(1, ((values[pixel] ?? 0) + 1) * .5))); image.data[offset] = value; image.data[offset + 1] = value; image.data[offset + 2] = value; }
      image.data[offset + 3] = 255;
    }
    context.putImageData(image, 0, 0);
  };
  for (const node of snapshot.nodes) { draw(`network-signal-${node.id}`, node.signal, false); draw(`network-contribution-${node.id}`, snapshot.contributions[String(node.id)] ?? [], true); }
  draw("network-final", snapshot.finalImage, true);
}
export function drawNetworkConnections(snapshot: { edges: Array<{ sourceId: number; targetId: number }> }, graph = document.querySelector<HTMLElement>(".network-graph")): void {
  if (!graph) return;
  const bounds = graph.getBoundingClientRect();
  const bottomToTop = graph.classList.contains("network-graph-bottom-to-top");
  let svg = graph.querySelector<SVGSVGElement>(".network-connections");
  if (!svg) { svg = document.createElementNS("http://www.w3.org/2000/svg", "svg"); graph.prepend(svg); }
  svg.setAttribute("class", "network-connections"); svg.setAttribute("viewBox", `0 0 ${bounds.width} ${bounds.height}`); svg.setAttribute("width", `${bounds.width}`); svg.setAttribute("height", `${bounds.height}`);
  const rectangles = new Map<number, DOMRect>();
  for (const id of new Set(snapshot.edges.flatMap(e => [e.sourceId, e.targetId]))) {
    const node = graph.querySelector(`#network-signal-${id}`);
    if (node) rectangles.set(id, node.getBoundingClientRect());
  }
  if (svg.children.length !== snapshot.edges.length) svg.replaceChildren(...snapshot.edges.map(() => document.createElementNS("http://www.w3.org/2000/svg", "line")));
  for (const [index, edge] of snapshot.edges.entries()) {
    const source = rectangles.get(edge.sourceId);
    const target = rectangles.get(edge.targetId);
    if (!source || !target) continue;
    const line = svg.children[index];
    line.setAttribute("data-source", String(edge.sourceId)); line.setAttribute("data-target", String(edge.targetId));
    line.setAttribute("x1", `${(bottomToTop ? source.left + source.width / 2 : source.right) - bounds.left}`);
    line.setAttribute("y1", `${(bottomToTop ? source.top : source.top + source.height / 2) - bounds.top}`);
    line.setAttribute("x2", `${(bottomToTop ? target.left + target.width / 2 : target.left) - bounds.left}`);
    line.setAttribute("y2", `${(bottomToTop ? target.bottom : target.top + target.height / 2) - bounds.top}`);
  }
}
